module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "600"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "coming-soon-modal"
  }, [_c('v-card-title', [_c('h2', {
    staticClass: "font card-title"
  }, [_vm._v("¡Aviso!")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font card-text"
  }, [_vm._v("\n      Esto es una funcionalidad solamente disponible en la versión paga."), _c('br'), _vm._v("Conocé más en "), _c('a', {
    on: {
      "click": _vm.openPoncePage
    }
  }, [_vm._v(_vm._s(_vm.VUE_APP_LANDING_PAGE_URL))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bb75fdd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/ComingSoonModal.vue
// module id = 758
// module chunks = 15